import React, { useEffect, useState } from "react";
import { PAGESIZE } from "../../../utils/constants";
import { FieldErrors } from "../../../domain/helpers/Errors";
import { useLanguageStore } from "../../../store/useLanguageStore";
import { TicketInterface } from "../../../models/TicketModule/Ticket";
import { TicketFinancialType } from "../../../enums/ticketFinancialType";
import useTicketColumns, { hideColumns } from "./Components/TableForm/TicketColumns";
import ToastMessage from "../../../common/ToastMessage";
import CustomDataGrid from "../../../common/CustomDataGrid";
import useDeleteRecTicket from "../../../store/ReactQueries/recurringTickets/useDeleteRecTicket";
import useRecurringTickets from "../../../store/ReactQueries/recurringTickets/useRecurringTickets";

export const RecurringTickets = () => {
    const { language } = useLanguageStore();

    const [errors, setErrors] = useState<FieldErrors>({});
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(PAGESIZE);
    const [form, setForm] = useState<TicketInterface>({
        id: "",
        title: "",
        description: "",
        statusId: "",
        categoryId: "",
        locationId: "",
        priorityId: "",
        customerId: "",
        contractorId: "",
        asset: null,
        assetId: null,
        departmentId: "",
        assignedTo: null,
        author: undefined,
        dueDate: undefined,
        assignedToId: null,
        interventionTypeId: "",
        financialAssignedToId: null,
        financialAssignedTo: null,
        ticketFinancialType: TicketFinancialType.Nonbillable,
        companyId: '',
        isRecurring: false,
    });

    let {
        data: tickets,
        isLoading,
        error: ticketErrors,
    } = useRecurringTickets(page, pageSize);

    const deleteTicket = useDeleteRecTicket(page, pageSize);

    const handleDelete = async (id: string) => {
        if (await ToastMessage.Confirm(language["ToastDeleteItem"])) {
            deleteTicket.mutate(id, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => {
                    if (error instanceof Error) ToastMessage.Failed(error.message);
                    else ToastMessage.Failed();
                },
            });
        }
    };

    const upHideColumns = [...hideColumns, 'isRecurring'];

    useEffect(() => {
        if (ticketErrors) ToastMessage.Failed(ticketErrors.message);
    }, [ticketErrors]);

    return <React.Fragment>
        <div className="w-100 p-2 d-flex align-items-center">
        </div>
        <div className="d-flex gap-2 w-100 flex-row">
            <div
                className='d-flex flex-column gap-2'
                style={{ width: '100%' }}
            >
                <CustomDataGrid
                    form={form}
                    errors={errors}
                    rows={tickets || []}
                    addItems={() => { }}
                    showColumnModal={[]}
                    hideColumns={upHideColumns}
                    columns={useTicketColumns()}
                    newAddComponent="RecurringTickets"
                    name={language["RecurringTickets"]}
                    handleSave={function (): Promise<void> {
                        throw new Error("Function not implemented.");
                    }}
                    modal={{
                        add: false,
                        edit: false,
                        view: false,
                    }}
                    setModal={function (
                        value: React.SetStateAction<{
                            add: boolean;
                            edit: boolean;
                            view: boolean;
                        }>
                    ): void {
                        throw new Error("Function not implemented.");
                    }}
                    page={page}
                    loading={isLoading}
                    pageSize={pageSize}
                    setPage={setPage}
                    setForm={setForm}
                    setErrors={setErrors}
                    setPageSize={setPageSize}
                    handleDelete={handleDelete}
                />
            </div>

        </div>
    </React.Fragment>
};
export default RecurringTickets;
